import * as React from "react";
import { Dropdown, IDropdownOption } from "office-ui-fabric-react";
import { Template } from "typings";


interface Props
{
    templates: Template[];
    onTemplateChange: (template?: Template) => void;
    title?: string;
}


const TemplateDropdown: React.FunctionComponent<Props> = props =>
{
   
    const dropdownOptions: IDropdownOption[] = [];
    if (props.title)
    {
        dropdownOptions.push( ({ text: props.title, key: "" }));
    }
    props.templates.forEach(x => dropdownOptions.push({ text: x.label._DEFAULT, key: x.id }));
    const onTemplateChange = (e: React.FormEvent<HTMLDivElement>, item: IDropdownOption) =>
    {
        const template = props.templates.find(x => x.id === item.key);
        props.onTemplateChange(template);
    };
    return (
        <Dropdown style={{width: 300}}
            onChange={onTemplateChange} required id="newProductTemplate" 
            placeholder={props.title} 
            options={dropdownOptions}  />
    );

};

export default TemplateDropdown;


// WEBPACK FOOTER //
// ./src/components/product/TemplateDropdown.tsx